export function GetProcessDirectLabel(processDirect?: boolean) {
  if (processDirect !== null && processDirect !== undefined) {
    if (processDirect) return 'Direto';
    return 'Indireto';
  }
  return '-';
}
